import React from 'react';

/** Swatch colours match `.schedule-gantt-viewport .wx-bar` rules in `App.css`. */
const ScheduleChartLegend: React.FC = () => {
  return (
    <div
      className="schedule-header-bar schedule-chart-legend schedule-chart-legend--below tw-shrink-0 tw-grow min-w-0"
      aria-label="Schedule chart colour key"
    >
      <div className="tw-text-sm tw-font-semibold tw-text-secondary tw-mb-1">Chart key</div>
      <div className="tw-flex tw-flex-col tw-gap-1">
        <div className="tw-flex tw-flex-wrap gap-x-3 gap-y-1 tw-items-center">
          <span className="schedule-legend-item">
            <span className="schedule-legend-swatch schedule-legend-swatch-overdue" aria-hidden />
            <span>Red — Overdue</span>
          </span>
          <span className="schedule-legend-item">
            <span className="schedule-legend-swatch schedule-legend-swatch-active" aria-hidden />
            <span>Green — Active</span>
          </span>
          <span className="schedule-legend-item">
            <span className="schedule-legend-swatch schedule-legend-swatch-closed" aria-hidden />
            <span>Light blue — Closed / Finalized</span>
          </span>
          <span className="schedule-legend-item">
            <span className="schedule-legend-swatch schedule-legend-swatch-planned" aria-hidden />
            <span>Blue — Planned</span>
          </span>
          <span className="schedule-legend-item">
            <span className="schedule-legend-swatch schedule-legend-swatch-summary" aria-hidden />
            <span>Grey — Resource / person summary row</span>
          </span>
        </div>
        <div className="tw-flex tw-flex-wrap gap-x-3 gap-y-1 tw-items-center tw-text-sm tw-text-content-muted tw-border-t tw-border-line tw-pt-1">
          <span>
            <strong className="tw-text-content">[CONFLICT]</strong> — overlapping assignment; adjust dates or resources.
          </span>
          <span className="tw-hidden sm:tw-inline">·</span>
          <span className="tw-flex tw-items-center tw-gap-1">
            <span className="schedule-legend-today-mark" aria-hidden />
            Vertical blue line — Today on the timeline
          </span>
        </div>
      </div>
    </div>
  );
};

export default ScheduleChartLegend;
